export default {
  common: {
    esg: {
      category: 'Kategori',
      environment: 'Lingkungan',
      society: 'Sosial',
      governance: 'Tata Kelola',
      other: 'Lainnya',
      comprehensive: 'Total',
      // basic: '',
    },
    btn: {
      cancel: 'Batalkan',
      add: 'Tambah',
      create: 'Buat',
      update: 'Perbarui',
      apply: 'Terapkan',
      close: 'Tutup',
      create_new: 'Buat Baru',
      edit: 'Edit',
      detail: 'Detail',
      view_detail: 'Detail',
      delete: 'Hapus',
      change: 'Ubah',
      confirm: 'Konfirmasi',
      clear: 'Atur ulang',
      download: 'Unduh',
      save: 'Simpan',
      register: 'Daftar',
      check_answer: 'Periksa jawaban',
      score_card_list: 'Daftar Kartu Skor',
      confirm_action: '@:common.btn.confirm',
      edit_action: '@:common.btn.edit',
      create_action: '@:common.btn.create',
      add_action: '@:common.btn.add',
      bulk_download: 'Unduhan Massal',
    },
    link: {
      delete: 'Hapus',
      back: 'Kembali',
    },
    sentence: {
      back_to_login: 'Kembali ke login',
      back_to_dashboard: 'Kembali ke dasbor',
      not_applicable: 'Tidak berlaku*',
      // back_to_top: '',
    },
    switch: {
      current_language: 'Language',
    },
    filter: {
      questionnaire: 'Survei',
      questionnaire_short: '@:common.filter.questionnaire',
      target_questionnaire: 'Pilih survei',
      target_year: 'Tahun',
      target_year_text: 'Pilih tahun',
      target_company: 'Perusahaan',
      target_company_text: 'Pilih perusahaan',
      total: 'Semua: {total}',
    },
    label: {
      required: 'Wajib Diisi',
      optional: 'Opsional',
      year: 'Tahun',
    },
    form: {
      search_word: {
        label: 'Pencarian kata gratis',
        placeholder: '@:common.placeholder.input_free',
      },
    },
    date: {
      dateFormatTemp: 'dd/MM/yyyy',
      dateTimeFormatTemp: 'dd/MM/yyyy HH:mm zzz',
      datePickerFormat: 'dd/MM/yyyy',
      datePickerPlaceholder: 'DD/MM/YYYY',
      issue_date: 'Tanggal terbit',
      evaluation_expires_date: 'Tanggal kedaluwarsa',
      answer_expires_date: 'Tenggat',
      // last_updated_date: '',
    },
    error: {
      code_0005: 'Autentikasi gagal. Silakan login lagi',
      code_0007: 'Pertanyaan ini wajib diisi',
      code_5001: 'Halaman tidak ditemukan.',
      code_0001: 'Survei terbaru telah dikirim',
      code_0002: 'Pembaruan gagal karena data terbaru diperbarui dari perangkat lain. Silakan muat ulang dan coba perbarui lagi.',
      code_0003: 'Gagal menghapus file. Silakan hapus setelah menjawab setidaknya satu pertanyaan.',
      code_0006: 'Pengguna sudah terdaftar',
      code_0004: 'File ini melebihi ukuran file yang dapat diunggah. Silakan dicatat bahwa ukuran file harus maksimal 50 MB.',
      code_9999: 'Terjadi kesalahan yang tidak terduga',
    },
    evaluation: {
      title: 'Minta Penilaian',
      dashboard: 'Dasbor',
      analysis: 'Analisis',
      list: 'Daftar perusahaan',
    },
    dashboard: {
      title: 'Dasbor',
    },
    upload: {
      title: 'Survei',
      common: 'Umum',
    },
    scorecard: {
      title: 'Kartu Skor',
      list: 'Daftar',
      detail: 'Detail',
      scorecard_detail: 'Detail Kartu Skor',
      answer_preview: 'Pratinjau Jawaban',
      // breadcrumb_detail: '',
    },
    improvementplans: {
      title: 'Rencana Peningkatan',
      detail: '@:common.scorecard.detail',
      // breadcrumb_detail: '',
    },
    detailExtra: {
      title: 'Analisis lanjutan',
    },
    settings: {
      title: 'Pengaturan',
    },
    // default_selector: {
    //   selected_label: '',
    //   do_select:      '',
    //   do_release:     '',
    // },
    contact: {
      title: 'Tanya Jawab Umum',
    },
    logout: {
      title: 'Keluar',
    },
    industry: {
      type_1: 'Pertanian, Kehutanan, dan Perikanan',
      type_2: 'Pertambangan, Penggalian, dan Ekstraksi Kerikil',
      type_3: 'Industri Konstruksi (Termasuk Konstruksi Fasilitas)',
      type_4: 'Industri Manufaktur (Besi, Baja, Logam Non-Besi, Produk Logam)',
      type_5: 'Industri Manufaktur (Mesin, Peralatan, Elektronik, dll.)',
      type_6: 'Industri Manufaktur (Makanan, Minuman, Tembakau, dll.)',
      type_7: 'Industri Manufaktur (Pulp, Kertas, Produk Kertas)',
      type_8: 'Industri Manufaktur (Kayu, Pengolahan Produk Kayu)',
      type_9: 'Industri Manufaktur (Industri Kimia, Termasuk Farmasi, Industri Tekstil)',
      type_10: 'Industri Manufaktur (Minyak Bumi, Batubara, Karet, Plastik, dll.)',
      type_11: 'Industri Manufaktur (Industri Percetakan)',
      type_12: 'Industri Manufaktur (Lainnya)',
      type_13: 'Industri Listrik, Gas, Pemanas, dan Air',
      type_14: 'Industri Informasi dan Komunikasi',
      type_15: 'Industri Transportasi dan Pergudangan',
      type_16: 'Industri Grosir dan Eceran',
      type_17: 'Industri Keuangan dan Asuransi',
      type_18: 'Industri Properti',
      type_19: 'Sekolah (termasuk Taman Kanak-kanak dan Pusat Penitipan Anak)',
      type_20: 'Industri Akomodasi dan Layanan Makanan',
      type_21: 'Industri Jasa yang Berkaitan dengan Kehidupan (Penatu, Pangkas Rambut, Kecantikan, Pemandian Umum, dll.)',
      type_22: 'Industri Medis dan Kesejahteraan',
      type_23: 'Industri Pembuangan Limbah dan Daur Ulang',
      type_24: 'Industri Perawatan Otomotif',
      type_25: 'Pemerintah Daerah, Otoritas Publik, dll.',
      type_26: 'Lainnya',
    },
    scale: {
      a: '1〜29 orang',
      b: '30〜99 orang',
      c: '100〜499 orang',
      d: '500〜999 orang',
      e: '1000〜4999 orang',
      f: 'lebih dari 5000 orang',
    },
    sales_amount: {
      under_1million: '~1 juta USD',
      under_10million: '1~10 juta USD',
      under_100million: '10~100 juta USD',
      under_1billion: '100 juta~1 miliar USD',
      under_10billion: '1~10 miliar USD',
      over_10billion: '10 miliar ~ USD',
      not_disclose: 'Tidak ingin mengungkapkan',
    },
    progress: 'Kemajuan',
    url: {
      contact: 'https://asuene.com/rating/en/form/contact',
      asuene: 'https://asuene.com/apac',
      asuene_lca: '---ja のみ表示---',
      asuene_career: 'https://asuene.com/career/biz',
      corporate: 'https://corp.asuene.com/en',
    },
    head_title: 'ASUENE ESG',
    company_name_inc: 'ASUENE Inc.',
    breakdown: 'Perincian',
    help: 'Bantuan',
    user_display_mode: {
      my_assessment: 'Penilaian saya',
      supply_chain_assessment: 'Penilaian rantai pasokan',
    },
    buyer: 'Pembeli',
    supplier: 'Pemasok',
    error_page: {
      section_one: 'Halaman tidak ditemukan',
      section_two: 'Periksa URL',
      to_dashboard: 'Kembali ke Dasbor',
    },
    priority: {
      good: 'Bagus',
      high: 'Tinggi',
      medium: 'Sedang',
      low: 'Rendah',
    },
    priority_full_name: {
      high: 'Risiko tinggi',
      medium: 'Risiko sedang',
      low: 'Risiko rendah',
    },
    faq: {
      how_to_use_csv_head: 'Untuk membuka file CSV yang diunduh di Excel, ikuti petunjuk di bawah ini.',
      how_to_use_csv_body_01: '1. Buka buku Excel kosong baru.',
      how_to_use_csv_body_02: "2. Pada tab 'Data', klik 'Dari Teks atau CSV'.",
      how_to_use_csv_body_03: "3. Pilih file CSV dan klik 'Impor'.",
      how_to_use_csv_body_04: '4. Konfirmasikan bahwa file telah diimpor dengan benar.',
      how_to_use_csv_body_05: "5. Pilih 'Muat'.",
      how_to_use_csv_note: '※ Prosedurnya dapat bervariasi tergantung sistem operasi dan versi Microsoft Excel yang digunakan.',
    },
    answer_display_status: {
      unanswered: 'Belum Dimulai',
      temporarily_saved: 'Sedang Berlangsung',
      submitted: 'Dikirim',
      score_rated: 'Dinilai',
      ended: 'Ditutup',
    },
    all: 'Semua',
    count: {
      // question: '',
      company: 'Perusahaan',
      unit: 'item',
      // number_of_questions_label: '',
    },
    esg_data_display_status: {
      unanswered: '@:common.answer_display_status.unanswered',
      temporarily_saved: '@:common.answer_display_status.temporarily_saved',
      // sharing: '',
      // unshared: '',
      // inviting: '',
      // viewable: '',
      // unviewable: '',
    },
    modal: {
      csv_download_mail_sended: {
        // title: '',
        message_one: '@:list_table_filter.csv_modal_sent_mail_section_one',
        message_two: '@:list_table_filter.csv_modal_sent_mail_section_two',
        message_three: '@:list_table_filter.csv_modal_sent_mail_section_three',
      },
    },
    status: 'Status',
    notification: {
      send_back: {
        // title: '',
        // description_1: '',
        // description_2: '',
        comment_label: '@:buyer_scorecard.answer_rejection_modal_text',
      },
      withdraw: {
        // title: '',
        // description_1: '',
        // description_2: '',
        // comment_label: '',
      },
      download: {
        // csv_success_title: '',
        // csv_description_1: '',
        // common_description: '',
        // action: '',
        // csv_failed_title: '',
        // failed_description_1: '',
        // failed_description_2: '',
        // pdf_success_title: '',
        // pdf_description_1: '',
        // pdf_failed_title: '',
      },
      message: {
        // title: '',
        // description: '',
      },
      company_name_label: '@:esg_data.company_name',
      message_label: '@:esg_data.message',
      data_share_invitation: {
        // title: '',
        // description: '',
        // person_label: '',
        data_label: '@:esg_data.data_name',
        // description_1: '',
        // description_2: '',
        // modal_description: '',
      },
      data_share_complete: {
        // title: '',
        // description: '',
      },
      answer_remind: {
        // title: '',
        // description: '',
      },
      // empty_description_1: '',
      // empty_description_2: '',
      // title: '',
      // unread: '',
    },
    buyer_create_question: {
      // title: '',
      // create_survey: '',
      // answer_list: '',
    },
    information: {
      // not_available: '',
      // please_wait: '',
    },
    action: {
      // delete_item: '',
    },
    category_icon: {
      // no_select: '',
      // water: '',
      // waste: '',
      // ghg: '',
      // human_rights: '',
      // occupational_safety: '',
      // security: '',
      // balance_scale: '',
      // icon: '',
      // check: '',
    },
    placeholder: {
      input_free: 'Masukkan',
      half_digits: 'Digit semilebar',
    },
  },
};
